<script setup>
/* eslint-disable */
import { ref, defineProps, watchEffect, inject, toRef } from 'vue'
import QRCode from "qrcode-generator";
const dialog = ref();
const qrcode = ref();
const service = inject('service');
const props = defineProps({
	target: String,
	size: { type: Number, default: 250 }
});
const target = ref(toRef(props.target));
const genState = ref('pending');
const isOpen = ref(false);
function open(newTarget) {
	if(newTarget !== undefined)
		target.value = newTarget;
	isOpen.value = true;
}
defineExpose({open})
watchEffect(async function() {
	if(!dialog.value) return;
	if(isOpen.value) try {
		dialog.value.showModal();
		const target_ = target.value instanceof Object
			? JSON.parse(JSON.stringify(target.value))
			: target.value;
		const container = qrcode.value;
		container.innerHTML = '';
		const short = service.shorten.url(target_);
		if(short instanceof Promise) genState.value = 'pending';
		const url = (short instanceof Promise) ? await short : short;
		genState.value = 'ok';
		console.log(url);
		navigator.clipboard.writeText(url);
		const qr = QRCode(0, 'L');
		qr.addData(url);
		qr.make();
		const dataUrl = qr.createDataURL(1, 0);
		const pixels = qr.getModuleCount();
		const pixelSize = Math.max(1, Math.ceil(props.size / pixels));
		const imgSize = pixelSize * pixels;
		container.innerHTML =
			`<img src="${dataUrl}" style="width:${imgSize}px;height:${imgSize}px;image-rendering:pixelated">`;
	} catch(e) { console.log(e); genState.value = 'error' }
	else dialog.value.close();
})
</script>
<template>
	<teleport to="body">
		<dialog @keydown="isOpen=false" ref="dialog">
			<div style="text-align:right">
				<MatFab @click="isOpen=false" mini icon="close" :title="$t('close')" style="box-shadow:none" />
			</div>
			<div class="d-flex flex-column align-items-center justify-content-center" style="margin: 0 10px 10px 10px">
				<span v-if="genState == 'ok'" class="pt-3">Le lien a été copié dans le presse-papier.</span>
				<span v-else-if="genState == 'pending'" class="pt-3">Génération...</span>
				<span v-else class="pt-3">Désolé, nous n'avons pas pu générer une URL courte.</span>
				<div ref="qrcode" style="margin-top:15px;"></div>
			</div>
			<div style="text-align:center">
				<MatButton raised @click="isOpen=false" label="Ok" />
			</div>
		</dialog>
	</teleport>
</template>
<style lang="scss" scoped>
dialog {
	border-radius: var(--border-radius);
	border: none;
	box-shadow: black 1px 1px 10px;
	&::backdrop {
		background-color: rgba(0, 0, 0, .5);
		backdrop-filter: blur(3px);
	}
}
</style>
